import { createTheme } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

import HAVDT from './HAVDesignTokens'

export const HAVTheme = createTheme({
  breakpoints: {
    values: {
      lg: 1440,
      md: 1024,
      sm: 768,
      xs: 360,
    },
  },
  HAVDesignTokens: {
    ...HAVDT,
  },
  newTheme: {
    ...theme,
  },
  palette: {
    background: {
      default: theme.colors.quartenary,
    },
    error: {
      main: theme.colors.support.error,
    },
    grey: {
      '50': theme.colors.neutral.mediumhover,
      '100': theme.colors.neutral.light,
      '900': theme.colors.neutral.medium,
    },
    info: {
      main: theme.colors.quartenary,
    },
    primary: {
      contrastText: theme.colors.neutral.white,
      main: theme.colors.primary.main,
    },
    secondary: {
      contrastText: theme.colors.neutral.black,
      main: theme.colors.secondary,
    },
    success: {
      main: theme.colors.support.success,
    },
    text: {
      disabled: theme.colors.neutral.white,
      primary: theme.colors.neutral.medium,
      secondary: theme.colors.neutral.light,
    },
    warning: {
      main: theme.colors.support.warning,
    },
  },
  shape: {
    borderRadius: 5,
  },
  spacing: 5,
  typography: {
    body1: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.sm,
      lineHeight: 'normal',
    },
    body2: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.xs,
      fontWeight: theme.typography.weight.lg,
      lineHeight: 'normal',
    },
    button: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.xs,
      fontWeight: theme.typography.weight.md,
    },
    fontFamily: theme.typography.family.primary,
    h1: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes['3xl'],
      fontWeight: theme.typography.weight.lg,
      lineHeight: 'normal',
    },
    h2: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes['2xl'],
      lineHeight: 'normal',
    },
    h3: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.xl,
      fontWeight: theme.typography.weight.lg,
      lineHeight: 'normal',
    },
    h4: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.lg,
      fontWeight: theme.typography.weight.md,
      lineHeight: 'normal',
    },
    h5: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes['2md'],
      fontWeight: theme.typography.weight.lg,
      lineHeight: 'normal',
    },
    subtitle1: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.md,
      fontWeight: theme.typography.weight.md,
      lineHeight: 'normal',
    },
  },
})

export default HAVTheme
